module.exports = "/images/PaintBall.svg?0387b8f1ad670089cc24a0d7d107bc94";